import { useRef } from 'react';
import { g as getOrInvoke } from './utils.es.js';

// https://github.com/Andarist/use-constant

function useConstant(valueOrFactory) {
  var ref = useRef();

  if (!ref.current) {
    ref.current = {
      v: getOrInvoke(valueOrFactory)
    };
  }

  return ref.current.v;
}

export default useConstant;
